import { Button, Icon } from '@toggle/design-system';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ChatInputProps } from '~/components/chat';
import { ModalTypes, useModal } from '~/hooks/use-modal/useModal';
import { useSubscription } from '~/stores/use-subscription/useSubscription';

import * as S from './EarningsChatInput.styles';

interface EarningsChatInputProps {
  renderChatInput?: (props?: ChatInputProps) => ReactElement;
  documentIds?: string[];
}

export const EarningsChatInput = ({
  renderChatInput,
  documentIds,
}: EarningsChatInputProps) => {
  const { t } = useTranslation(['chat', 'asset-overview']);
  const isBasicUser = useSubscription(state => state.isBasicUser());

  const { open, close, isOpen } = useModal(ModalTypes.SearchDocuments);

  const renderChatInputProps: ChatInputProps = {
    chatContext: { documents: documentIds },
    config: {
      placeholder: t('chat:placeholder', { context: 'quickAnalysis' }),
      persistInputTextOnSubmit: true,
      clearDocumentContextOnSubmit: true,
      disableContextHeader: true,
      allowedModes: [],
    },
  };

  if (isBasicUser) {
    return null;
  }

  return (
    <div>
      <S.ChatInputWrapper onClick={open}>
        <S.StyledInput
          leftIcon={
            <S.AlfredIconWrapper>
              <Icon iconName="Alfred" size={24} />
            </S.AlfredIconWrapper>
          }
          rightIcon={
            <Button label={t('asset-overview:documentSearch.askQuestion')} />
          }
          placeholder={t('asset-overview:documentSearch.buttonText')}
        />
      </S.ChatInputWrapper>
      <S.StyledModal
        isOpen={isOpen}
        onClose={close}
        description={!!renderChatInput && renderChatInput(renderChatInputProps)}
      />
    </div>
  );
};
